<template>
  <div>
    <div class="title">
      <div class="title_logo">
        <img :src="logo" alt="" srcset="">
      </div>
    </div>
    <div class="tar">
      <div style="
            width: 30%;
            height: 100%;
            display: flex;
            justify-content: space-around;  ">
        <div class="tar_li" :class="{ tar_back: selectTab_item === 'Monitor' }" @click="sigg('Monitor')">监控云</div>
        <!-- <div class="tar_li" :class="{ tar_back: selectTab_item === 'Net_connection' }" @click="sigg('Net_connection')">
          新能源</div> -->

        <div class="tar_li" :class="{ tar_back: selectTab_item === 'Car_monitoring' }" @click="sigg('Car_monitoring')">
          智车监控
        </div>
        <div class="tar_li" :class="{ tar_back: selectTab_item === 'CarInfoTypeTwo' }" @click="sigg('CarInfoTypeTwo')">
          状态监控
        </div>
        <!-- <div style="  width: 22%;
  height: 80%;
  text-align: center;
  font-size: 14px;
  color: #ffffff;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;"></div> -->
      </div>
      <div style="width: 40%; height: 100%; float: right"></div>
      <div style="
            width: 30%;
            height: 100%;
            display: flex;
            justify-content: space-around;
          ">
        <!-- <div class="tar_li" :class="{ tar_back: selectTab_item === 'Op_manager' }" @click="sigg('Op_manager')">运维管理
        </div>
        <div class="tar_li" @click="sigg('diaodu')">运维调度</div> -->
        <div class="tar_li" @click="tuichu = true">退出</div>
      </div>
    </div>
  </div>

  <el-dialog v-model="tuichu" title="系统提示" width="30%" :before-close="handleClose">
    <span>确定退出吗？</span>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="tuichu = false">取消</el-button>
        <el-button type="primary" @click="exit()">确认</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { reactive, toRefs, onMounted, watch, computed } from "vue";
import { logout } from "../api/tar/api";
import { useRouter } from "vue-router";
import { useStore } from 'vuex'
let time = ''
export default {
  name: "tar",
  setup() {
    const router = useRouter();
    const store = useStore();
    const selectTab = computed(() => store.state.selectTab_item)
    const data = reactive({
      selectTab_item: "Monitor",
      dialogFormVisible: false,
      tuichu: false,
      user_info: "",
      role_ids: '',
      value: "",
      code: '',
      formLabelWidth: "80px",
      logo: "",
    });

    //单击退出
    const exit = () => {
      router.push("./Login");
      localStorage.clear();
    };
    //切换背景  跳转路由
    const sigg = (val) => {
      data.selectTab_item = val;
      if (val === "Op_manager") {
        window.location.href = "http://112.124.24.180:2021";
      } else if (val === 'Net_connection') {
        window.location.href = "http://112.124.24.180:8699";
      } else {
        localStorage.setItem("selectTab_item", val);
        router.push({ name: val });
      }
    };
    const gorouter = () => {
      //保存背景状态和路由
      if (localStorage.getItem("selectTab_item")) {
        data.selectTab_item = localStorage.getItem("selectTab_item");
        router.push({ name: data.selectTab_item });
      }
    }
    const info = () => {
      let value = localStorage.getItem("info");
      value = JSON.parse(value)
      data.logo = value.cloudControlLogo
    }
    info()
    watch(selectTab, () => {
      data.selectTab_item = selectTab.value;
    })
     gorouter();
    return {
      sigg,
      ...toRefs(data),
      exit,


    };
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: none;
  color: rgb(255, 255, 255);
}

.title {
  width: 100%;
  height: 9%;
  position: absolute;
  z-index: 100;
  background-image: url("../assets/img/top_title2.png");
  background-size: 100% 100%;

  display: flex;
  justify-content: center;
}

.title_logo {
  width: 20%;
  height: 75%;
  // background-image: url("../assets/img/top_title2.png");
  // background-size: 100% 100%;
  // text-align: center;
  // font-size: 2rem;
  // color: #ffffff;
  // padding-left: 4%;
  // padding-top: 0.8%;
  // text-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
  // margin-left: 20px;
}

.title_logo img {
  width: 100%;
  height: 100%;
}

.tar {
  width: 100%;
  height: 6%;
  top: 4.5%;
  position: absolute;
  z-index: 101;
  display: flex;
}

.tar_li {
  width: 22%;
  height: 80%;
  text-align: center;
  font-size: 14px;
  color: #ffffff;
  background-image: url("../assets/img/menu_normal.png");
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer
}

.tar_li1 {
  width: 22%;
  height: 80%;
  text-align: center;
  font-size: 14px;
  color: #ffffff;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tar_back {
  background-image: url("../assets/img/menu_hover.png");
  cursor: pointer
}

</style>